/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface ProductData
 */
export interface ProductData {
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    productName?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductData
     */
    amount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductData
     */
    turnover?: MoneyOutput;
}

/**
 * Check if a given object implements the ProductData interface.
 */
export function instanceOfProductData(value: object): value is ProductData {
    return true;
}

export function ProductDataFromJSON(json: any): ProductData {
    return ProductDataFromJSONTyped(json, false);
}

export function ProductDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductData {
    if (json == null) {
        return json;
    }
    return {
        
        'productName': json['productName'] == null ? undefined : json['productName'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
    };
}

export function ProductDataToJSON(json: any): ProductData {
    return ProductDataToJSONTyped(json, false);
}

export function ProductDataToJSONTyped(value?: ProductData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productName': value['productName'],
        'amount': value['amount'],
        'turnover': MoneyOutputToJSON(value['turnover']),
    };
}

